module.exports = __webpack_public_path__ + "static/media/M71ws.c5a50a6c.pdf";